import axios from 'axios';
import authHeader from './auth-header';


class KpiService {


  kpisGroup = ["er_supervise", "mitre_attack", "perimetre_supervise", "log"];
  kpisLabel = ["ER supervisés", "Mitre attack", "Périmètres supervisés", "Volume journalier de logs"];
  kpisProperties = ["value", "report_name", "report_result", "report_result"];

  getKpis(kpisCodes) {
    if (kpisCodes != undefined) {
      return axios.get(process.env.REACT_APP_API_URL + 'kpis?kpisCodes='+kpisCodes, { headers: authHeader() });
    }else{
      return axios.get(process.env.REACT_APP_API_URL + 'kpis', { headers: authHeader() });
    }
  }
  
  getKpi(code) {
    return axios.get(process.env.REACT_APP_API_URL + 'kpis/'+code, { headers: authHeader() });
  }

  upsertKpi(code, document) {
    return axios.post(process.env.REACT_APP_API_URL + 'kpis/'+code, {"kpiDocument": document}, {headers: authHeader()});
  }


  setGenerate() {
    return axios.post(process.env.REACT_APP_API_URL + 'kpis/generate', {}, {headers: authHeader()});
  }

  setCompute(code) {
    if(code)
    {
      return axios.post(process.env.REACT_APP_API_URL + 'kpis/compute?kpiCodes='+code, {}, {headers: authHeader()});
    }
    return axios.post(process.env.REACT_APP_API_URL + 'kpis/compute', {}, {headers: authHeader()});
    
  }
  
  getSavedSearch(code, repport_name) {
    return axios.post(process.env.REACT_APP_API_URL + 'kpis/'+code+'/savedsearches/'+repport_name, {}, {headers: authHeader()});
  }
}

export default new KpiService();